<template>
  <div id="ClassManage">
    <div v-if="ClassManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <div>
        
          目前高中職入班和集中宣導活動共 {{ total }}筆
           
        </div>

        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>
          
        
          <button
            href="#"
            @click.prevent="getALLClassList()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>
          <button
            href="#"
            @click.prevent="reset()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            清除重來
          </button>

          <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX9/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                
            "
            v-show="total > 0 && queryInfo.sActiveTime!=null && queryInfo.eActiveTime != null "
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
        </div>
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 2em">序號</b-th>
                <b-th style="min-width: 2em">活動編號</b-th>
                <b-th style="min-width: 3em">活動名稱</b-th>
               <b-th style="min-width: 5em">活動開始時間</b-th>
                <b-th style="min-width: 5em">活動結束時間</b-th>
                <b-th style="min-width: 2em">班級名稱</b-th>
                
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.aid"
                :index="item.aid"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.aid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.activeClass }}
                </b-td>
                <b-td style="text-align: left">{{ item.sActiveDate }}</b-td>
                <b-td style="text-align: left">{{ item.eActiveDate }}</b-td>
                <b-td style="text-align: left">{{ item.classNames }}</b-td>
             
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      
    </div>

    
  </div>
</template>


<script>

import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "ClassManage",
  data() {
    return {
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      ClassManageShow: false,
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: {
        sActiveTime: null,
        eActiveTime: null,
      },
      inputData2: null,
      inputData7: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        //defaultDate: null, // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        eid:0,
        aid:0,
        sActiveTime: null,
        eActiveTime: null,
        sActiveDate: null,
        eActiveDate: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        enrollTypeName: null,
      },
    };
  },
  components: {
   
    flatPickr,
  },
  methods: {
    reset() {
      let vm = this;
      vm.queryInfo = {
        eid:0,
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        enrollTypeName: null,
      };
      vm.ClassManageShow = true;
    },
     getALLClassList() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetALLClassList/"
          .concat(vm.queryInfo.sActiveTime)
          .concat('/')
          .concat(vm.queryInfo.eActiveTime)
          
        )
        .then((response) => {
          if (!tools.isNull(response) && response.data.length > 0) {
            vm.inputData = response.data;
            console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;

            
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
 },
      
  computed: {
  
    filteredDocs: function () {
      let data = [];
      data = Array.isArray(this.inputData)
        ? this.inputData.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize
          )
        : [];
      return data;
    },
    filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },

  },
  created() {
    console.log("======created ClassManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.ClassManageShow = true;

  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
